// extracted by mini-css-extract-plugin
module.exports = {"grid":"gallery-module--grid--mTRh5"};